// extracted by mini-css-extract-plugin
export var pillWrapper = "_pd-0";
export var showOverflow = "_pd-1";